import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LoaderService {
    public loaderSubject = new Subject<boolean>();
    public loaderObservable = this.loaderSubject.asObservable();
}
